import { Controller } from "@hotwired/stimulus"

// Flips the document theme instantly, then persists the choice server-side.
export default class extends Controller {
  static targets = ["sun", "moon"]
  static values = { url: String }

  connect() {
    this.render()
  }

  toggle() {
    const theme = this.current() === "dark" ? "light" : "dark"
    document.documentElement.dataset.theme = theme
    this.render()
    this.persist(theme)
  }

  render() {
    const dark = this.current() === "dark"
    this.sunTarget.classList.toggle("hidden", !dark)
    this.moonTarget.classList.toggle("hidden", dark)
  }

  current() {
    return document.documentElement.dataset.theme
  }

  persist(theme) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded", "X-CSRF-Token": token },
      body: new URLSearchParams({ theme })
    })
  }
}
